import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { timer } from 'rxjs';
import { debounceTime } from '../../shared/constants/constants';
var checkIfNameExists = function (projectsService, inputValue) {
    return projectsService
        .checkIfNameExists(inputValue)
        .pipe(map(function (_a) {
        var exists = _a.exists;
        return (exists ? { unique: true } : null);
    }));
};
var ɵ0 = checkIfNameExists;
export var ValidateUniqueName = function (projectsService, startValue) { return function (_a) {
    var inputValue = _a.value;
    return timer(debounceTime).pipe(switchMap(function () { return (startValue === inputValue ? of(null) : checkIfNameExists(projectsService, inputValue)); }));
}; };
export { ɵ0 };
